import {
  DELETE_MIXTUREORDER_REQUEST,
  DELETE_MIXTUREORDER_ERROR,
  DELETE_MIXTUREORDER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_MIXTUREORDER_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_MIXTUREORDER_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_MIXTUREORDER_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixtureOrder";
  context.entityLocation = RESOURCES.MixtureOrders;

  return context.execute(context)(entity)(state, action);
};

